import './BreathingExerciseOrb.scss'

import { useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import cn from 'classnames'

import { navigateTo } from 'components/common/navigation'
import useBreathingAnimationFrame from 'components/common/hooks/useBreathingAnimationFrame'

/**
 * Breathing exercise orb component
 * @param {object} params Initialization params
 */
export default function BreathingExerciseOrb({
  breathingData,
  practiceMinutes,
  returnPath
}) {
  const isLargeScreen = useMediaQuery({ minWidth: 768 })
  const isSmallScreen = useMediaQuery({ maxWidth: 767 })
  const history = useHistory()
  const {
    secondsRemaining,
    minutesRemaining,
    animationState,
    countdown,
    isFinished
  } = useBreathingAnimationFrame(practiceMinutes, breathingData)

  // Start the animation when the component mounts
  useEffect(() => {}, [breathingData])

  // Return early if we don't have data
  if (!breathingData) return null

  return (
    <div
      className={cn('orb-container', {
        'small-screen-orb': isSmallScreen,
        'large-screen-orb': isLargeScreen,
        [animationState?.className]: animationState,
        finished: isFinished
      })}
    >
      <div className='animation-text justify-content-center text-center'>
        {isFinished ? (
          <div className='justify-content-center'>
            <h1 className='title text-center mb-4'>
              Your {practiceMinutes} minute{practiceMinutes === 1 ? '' : 's'} of
              breathwork {practiceMinutes === 1 ? 'is' : 'are'} complete
            </h1>
            <Button
              className='btn btn-primary btn-lg px-5 mt-4'
              onClick={() => {
                navigateTo(returnPath, history)
              }}
            >
              Done
            </Button>
          </div>
        ) : (
          <>
            <h1
              className='title'
              style={{
                animationDuration: `${animationState?.duration || 0}s`
              }}
            >
              {animationState?.message}
            </h1>
            <h2 className='subtitle'>{countdown}</h2>
            <div className='d-flex justify-content-center'>
              <span className='time'>
                {minutesRemaining < 10
                  ? `0${minutesRemaining}`
                  : minutesRemaining}
                :
                {secondsRemaining < 10
                  ? `0${secondsRemaining}`
                  : secondsRemaining}
              </span>
            </div>
          </>
        )}
      </div>
      <div className='orb-animation-wrapper'>
        <div
          className='breathing-orb'
          style={{
            animationDuration: `${animationState?.duration || 0}s`
          }}
        />
        <div
          className='breathing-orb-outer-bounds'
          style={{
            animationDuration: `${animationState?.duration || 0}s`
          }}
        />
        <div
          className='breathing-orb-inner-bounds'
          style={{
            animationDuration: `${animationState?.duration || 0}s`
          }}
        />
        <div className='breathing-orb-minute-bounds' />
      </div>
    </div>
  )
}
